import { render } from "./CurriculumList.vue?vue&type=template&id=4a0d06a2"
import script from "./CurriculumList.vue?vue&type=script&lang=js"
export * from "./CurriculumList.vue?vue&type=script&lang=js"

import exportComponent from "C:\\java\\workspace\\yonsei_tams2_web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__